import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import Modal from '../Modal/modal';
import PeriodoSelector from './periodo-selector';

interface DropdownModalOption {
  value: string;
  action: () => void;
  dateSelection?: boolean;
}

interface DropdownModalProps {
  visible: boolean;
  title: string;
  label: string;
  options: DropdownModalOption[];
  value?: string;
  onValueChange: (value: string) => void;
  onConfirm: () => void;
  onHide: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  selectedReport?: DropdownModalOption;
  dateRange: Date[] | null;
  onDateRangeChange: (dates: Date[] | null) => void;
}

const DropdownModal: React.FC<DropdownModalProps> = ({
  visible,
  title,
  label,
  options,
  value,
  onValueChange,
  onConfirm,
  onHide,
  confirmLabel = 'OK',
  cancelLabel = 'Cancelar',
  selectedReport,
  dateRange,
  onDateRangeChange,
}) => {
  const [resetKey, setResetKey] = useState(0);
  const [isPeriodoOverlayOpen, setIsPeriodoOverlayOpen] = useState(false);

  useEffect(() => {
    if (!selectedReport?.dateSelection) {
      onDateRangeChange(null);
      setResetKey((key) => key + 1);
    }
  }, [selectedReport, onDateRangeChange]);

  const content = (
    <div className="dropdown-modal-content">
      <label htmlFor="dropdown-modal-select">{label}</label>
      <Dropdown
        id="dropdown-modal-select"
        value={value}
        options={options}
        optionLabel="value"
        optionValue="value"
        onChange={(event: DropdownChangeEvent) =>
          onValueChange(event.value as string)
        }
        className="w-full"
      />
      {selectedReport?.dateSelection && (
        <PeriodoSelector
          key={resetKey}
          dateRange={dateRange}
          onDateRangeChange={onDateRangeChange}
          onOverlayVisibleChange={setIsPeriodoOverlayOpen}
        />
      )}
    </div>
  );

  return (
    <Modal
      visible={visible}
      title={title}
      content={content}
      className="dropdown-modal"
      position="top"
      actionsClassName="dropdown-modal-footer"
      actions={[
        {
          label: confirmLabel,
          onClick: onConfirm,
          buttonProps: {
            disabled: isPeriodoOverlayOpen,
            className: 'button-primary',
          },
        },
        {
          label: cancelLabel,
          onClick: onHide,
          buttonProps: {
            disabled: isPeriodoOverlayOpen,
            className: 'button-warning',
          },
        },
      ]}
      onHide={onHide}
    />
  );
};

export default DropdownModal;
